import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { MapSubtopicOne } from "../../objects/Tema4/subtopicOne/MapSubtopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { Billetes } from "../../objects/Tema4/subtopicOne/billetes";
import { Monitor } from "../../objects/Tema4/subtopicOne/monitor";

export class SceneTopicThree extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.environment = enviroment;
		this.characterSelected = character;
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.billetes = new Billetes(this.loadingManager);
		this.billetes.visible = false;
		this.add(this.billetes)

		this.monitor = new Monitor(this.loadingManager);
		this.monitor.visible = false;
		this.add(this.monitor)
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			default:
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.4;
				this.camera.control.maxDistance = 2;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityOne.showBillets, () => {
			this.billetes.visible = true;
			this.billetes.onAnimate()
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityOne.hideBillets, () => {
			this.billetes.visible = false;
			this.billetes.clearAnimation()
		})
	}

	renderAnimations(delta) {
		//animaciones
	}
}